import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { Table, RWTable } from "common/data/table";

export function docEntityTableFilter<T extends DocEntityBase>(
  entities: Table<T>,
  predicate: (entity: T) => boolean,
): { newTable: Table<T>; deletedIds: string[] } {
  const copy: RWTable<T> = {};
  const deletedIds: string[] = [];

  for (const id in entities) {
    const e = entities[id];

    if (predicate(e)) {
      copy[id] = e;
    } else {
      deletedIds.push(id);
    }
  }

  return { newTable: copy as Table<T>, deletedIds };
}
